export * from './no-right-click.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/no-right-click/index.ts